import { Component, Input, OnDestroy, OnInit } from '@angular/core';
import { NavParams } from '@ionic/angular';
import { LoggerService } from 'src/app/services/logger/logger.service';
import { BASE_CONFIG } from 'src/app/util/base-settings';
import { COMPONENT_NAME } from 'src/app/util/constants';

@Component({
  selector: 'app-ion-date-time-picker',
  templateUrl: './ion-date-time-picker.component.html',
  styleUrls: ['./ion-date-time-picker.component.scss'],
})
export class IonDateTimePickerComponent implements OnInit, OnDestroy {

  @Input() selDate : any = '';
  @Input() maxDate : any = "2050-12-31" ;
  @Input() minDate : any = "2000-01-01" ; 
  @Input() title : string;
  onDateSel : any;
  isWeb: boolean = BASE_CONFIG.IS_WEB;
  constructor(
    private logger : LoggerService,
    private navParams: NavParams
  ) { 
    this.selDate=this.navParams.data.propsData.selDate;
    this.maxDate=this.navParams.data.propsData.maxDate;
    this.minDate=this.navParams.data.propsData.minDate;
    this.title=this.navParams.data.propsData.title? this.navParams.data.propsData.title : '';
  }

  ngOnInit() {
  }

  ngAfterViewInit() {
    try {
      if (BASE_CONFIG.IS_DEBUG) console.log("ngAfterViewInit");

      if (this.isWeb) {
        setTimeout(() => {
          this.onClickPaymentDate();
        }, 50);
      }
    } catch (error) {
      let logRequest = this.logger.buildRequest(
        COMPONENT_NAME.ION_DATE_TIME_COMPONENT,
        'error in ngAfterViewInit',
        error.toString(),
        'ngAfterViewInit',
      );
      this.logger.log(logRequest);
    }
  }

  async onDatePicked(event)
  {
    try {
      if (BASE_CONFIG.IS_DEBUG) console.log("onDatePicked");
      
      this.selDate = event.target.value;
      if (this.isWeb && this.selDate) {
        this.onDateSel(this.selDate);
      }
      
    } catch (err) {
      let logRequest = this.logger.buildRequest(
        COMPONENT_NAME.ION_DATE_TIME_COMPONENT,
        'error in onDatePicked',
        err.toString(),
        'onDatePicked',
      );
      this.logger.log(logRequest);
    }
  }

  onSubmitDate() {
    try {
      if (BASE_CONFIG.IS_DEBUG) console.log("onDatePicked");
      
      if (this.selDate) {
        this.onDateSel(this.selDate);
      }
      
    } catch (err) {
      let logRequest = this.logger.buildRequest(
        COMPONENT_NAME.ION_DATE_TIME_COMPONENT,
        'error in onDatePicked',
        err.toString(),
        'onDatePicked',
      );
      this.logger.log(logRequest);
    }
  }

  onClickPaymentDate()
  {
    try {
      if (BASE_CONFIG.IS_DEBUG) console.log("onClickPaymentDate");

      (document.getElementById('date-picker') as any).showPicker();
    } catch (error) {
      let logRequest = this.logger.buildRequest(
        COMPONENT_NAME.ION_DATE_TIME_COMPONENT,
        'error in onClickPaymentDate',
        error.toString(),
        'onClickPaymentDate',
      );
      this.logger.log(logRequest);
    }
  }

  ngOnDestroy(): void {
    try {
      if (BASE_CONFIG.IS_DEBUG) console.log("ngOnDestroy");

      if (document.body.classList.contains('date-modal')) {
        document.body.classList.remove('date-modal');
      }

      if (document.body.classList.contains('app')) {
        document.body.classList.remove('app');
      }
    } catch (error) {
      let logRequest = this.logger.buildRequest(
        COMPONENT_NAME.ION_DATE_TIME_COMPONENT,
        'error in ngOnDestroy',
        error.toString(),
        'ngOnDestroy',
      );
      this.logger.log(logRequest);
    } 
  }

}
